<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input
            placeholder="请输入关键词"
            v-model="ruleForm.number"
          ></el-input>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <div>
        <span
          class="
            attention
            margin-top10 margin-bot10 margin-left20 margin-right20
          "
          @click="Initiateasale()"
          >发起采购</span
        >
        <span
          class="attention margin-top10 margin-bot10 margin-right20"
          @click="initiatemy()"
          >我的采购</span
        >
      </div>
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <div class="width100 margin-auto flexleft">
            <div
              class="width30 border-df border-rd3 margin-top20 margin-left20"
              style="padding: 10px; min-width: 500px"
              v-for="(item, index) in pages"
              :key="index"
            >
              <div class="bordert-bf flex pad-bot10">
                <div class="width30">
                  <el-image
                    :src="
                      item.image == null || item.image == ''
                        ? ''
                        : item.image.indexOf('http') == -1
                        ? picturehead + item.image
                        : item.image
                    "
                    class="border-rd3 width100"
                    style="height: 100px"
                  >
                    <div
                      slot="error"
                      class="image-slot textalign-center lineheight100 f22"
                      style="border: 1px solid #f0f0f0"
                    >
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <p class="f12 overhide">
                    行业：<span style="color: #e55343">{{
                      item.industry.name
                    }}</span>
                  </p>
                </div>

                <div class="pad-left10 width70">
                  <p class="flex-between">
                    <span class="f18 fw600">{{ item.title }}</span
                    ><span class="f14" style="color: #e55343"
                      >估值:{{ item.price }}万元</span
                    >
                  </p>
                  <p class="flex-between margin-top5 f14">
                    <span>{{ companytitle }}</span
                    ><span>{{ item.transfer.name }}</span>
                  </p>
                  <p
                    class="f14 lineheight20 corlor93 margin-top5 overheighthide"
                    v-html="item.remark"
                  ></p>
                  <p class="bluecolor f14 margin-top10"></p>
                </div>
              </div>
              <div class="pad-top10 flex-betweenNowrapAlign f14 cursorpointer">
                <div>
                  <span class="pad-left10" style="color: #e55343">
                    {{
                      pages[index].status == 1
                        ? "进行中"
                        : pages[index].status == 2
                        ? "已成交"
                        : "已关闭"
                    }}</span
                  >
                </div>
                <p class="f12 overhide">
                  截止时间：<span style="color: #e55343">{{
                    item.end_date
                  }}</span>
                </p>
                <div>
                  <span style="color: #52c5cb" @click="initiatedetail(index)"
                    >详情</span
                  >
                  <span
                    class="cursorpointer margin-left10"
                    :class="pages[index].status == 1 ? 'bluecolor' : ''"
                    @click="Initiateedit(index)"
                    >编辑</span
                  >
                  <span
                    class="f14 cursorpointer margin-left10"
                    :class="pages[index].status == 1 ? 'bluecolor' : ''"
                    @click="Submitfromnull(index)"
                  >
                    <span>删除</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="parseInt(per_page)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  productpurchaseindex,
  productpurchasedelete,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      serchkey: true,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 0,
      companytitle: "",
      pagination: false,
      allpage: [],
      ruleForm: {
        number: "",
      },
      defaultid: "",
      picturehead: "",
    };
  },
  components: {
    callback,
    switchcore,
  },
  inject: ["reload"],
  methods: {
    // 发起采购
    Initiateasale() {
      this.$router.push({ path: "/Results-trading/Sell-asale" });
    },
    // 成果编辑
    Initiateedit(index) {
      if (this.pages[index].status == 1) {
        window.sessionStorage.setItem("Sellofresultsid", this.pages[index].id);
        this.$router.push({ path: "/Results-trading/Sell-edit" });
      } else {
        return;
      }
    },
    // 详情
    initiatedetail(index) {
      window.sessionStorage.setItem("Sellofresultsid", this.pages[index].id);
      this.$router.push({ path: "/Results-trading/Sell-detail" });
    },
    // 我的采购
    initiatemy() {
      this.$router.push({ path: "/Results-trading/Sell-my" });
    },

    // 清空input
    resetForm() {
      this.ruleForm.number = "";
      this.thisNum = 1;
      productpurchaseindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      productpurchaseindex({
        _keywords: this.ruleForm.number,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除
    Submitfromnull(index) {
      if (this.pages[index].status == 1) {
        this.$confirm("此操作将取消采购此成果, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            productpurchasedelete({ id: this.pages[index].id }).then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.refresh();
              } else {
                this.drawer = false;
                this.dialogVisiblenull = true;
                this.errormessage = res.data.msg;
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      } else {
        return;
      }
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      productpurchaseindex({
        page: val,
        _keywords: this.ruleForm.number,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      productpurchaseindex({
        page: 1,
        limit: val,
        _keywords: this.ruleForm.number,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      productpurchaseindex({
        page: this.thisNum,
        _keywords: this.ruleForm.number,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.defaultid = window.sessionStorage.getItem("default");
    this.companytitle = window.sessionStorage.getItem("companytitle");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    this.picturehead = window.g.Apisrc;
    this.$loading.show(); // 显示loading
    productpurchaseindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.grenn {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7b83ea;
  position: relative;
  top: -1px;
  left: -5px;
}
.grenns {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #52c5cb;
  position: relative;
  top: -1px;
  left: -5px;
}
.grennss {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #bfc6d3;
  position: relative;
  top: -1px;
  left: -5px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>